export const verifyFields = (data, num) => {
    const testValues = Object.values(data);
    const verifyValues = testValues.map((item) => String(item).replace(/\s+/g, ""));
    const areValid = verifyValues.every((item) => item !== "" && item.length >= num);
    return areValid
}